export default {
	data() {
		return {
			mounted: false
		};
	},
	mounted() {
		this.mounted = true;
	},
	props: {
		display: {
			type: Boolean,
			default: false
		},
		position: {
			type: String,
			default: 'top',
			validator: function validator(value) {
				return (
					[
						'auto',
						'auto-start',
						'auto-end',
						'top',
						'top-start',
						'top-end',
						'bottom',
						'bottom-start',
						'bottom-end',
						'right',
						'right-start',
						'right-end',
						'left',
						'left-start',
						'left-end'
					].indexOf(value) > -1
				);
			}
		},
		positionStrategy: {
			type: String,
			default: 'fixed',
			validator: function validator(value) {
				return ['fixed', 'absolute'].indexOf(value) > -1;
			}
		},
		trackedRefName: {
			type: [String, HTMLElement],
			default: undefined
		},
		// [0, 5] offset is used to add a gap between the element and the target [x, y]
		offset: {
			type: Array,
			default: () => []
		}
	},
	computed: {
		trackedRef() {
			let ref;
			if (this.mounted) {
				if (
					this.$parent.$refs[this.trackedRefName] &&
					typeof this.trackedRefName === 'string'
				) {
					ref =
						this.$parent.$refs[this.trackedRefName].$el ||
						this.$parent.$refs[this.trackedRefName];
				} else {
					ref = this.trackedRefName;
				}
			}

			return ref;
		}
	}
};
